// extracted by mini-css-extract-plugin
export default {"hidden":"PortfolioItem_hidden__vCRjc","item":"PortfolioItem_item__7NVxJ","info":"PortfolioItem_info__Y1H4C"};